module.exports = __webpack_public_path__ + "img/bg_moon.074aca1e.png";